/**
 * Проверка ключа Яндекс.Карт так, как его использует кабинет: настоящим поиском адреса через
 * HTTP-геокодер (см. helpers/yandexGeocoder).
 *
 * Запрос идёт из браузера с cabinet.mison.uz: если в настройках ключа заданы разрешённые
 * домены, Яндекс сверит их по Referer, поэтому ловится и недействительный ключ, и ключ,
 * где наш домен не разрешён, и ключ не от того продукта (например, «JavaScript API»
 * нового кабинета — геокодер его не принимает).
 */
import { yandexGeocode } from 'helpers/yandexGeocoder'

const CHECK_TIMEOUT_MS = 12000

export async function checkYandexMapKey(apiKey) {
	const key = String(apiKey || '').trim()
	if (!key) return { ok: false, reason: 'empty' }

	const timeout = new Promise((resolve) => setTimeout(() => resolve({ ok: false, reason: 'timeout' }), CHECK_TIMEOUT_MS))
	const check = yandexGeocode(key, 'Ташкент', { results: 1 }).then(
		(list) => list.length > 0 ? { ok: true } : { ok: false, reason: 'empty_result' },
		() => ({ ok: false, reason: 'rejected' })
	)

	return Promise.race([check, timeout])
}
